import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query/react'
import { StoreEnhancer } from 'redux'
import { load, save } from 'redux-localstorage-simple'
import { isDevelopmentEnv, isProductionEnv, isTestEnv } from 'utils/env'

import { updateVersion } from './global/actions'
import { sentryEnhancer } from './logging'
import reducer from './reducer'
import { routingApi } from './routing/slice'

const PERSISTED_KEYS: string[] = ['user', 'transactions', 'lists']
let enhancers: StoreEnhancer[] = []

const isDevEnv: boolean = isDevelopmentEnv()
const isProdEnv: boolean = isProductionEnv()

if (isProdEnv) {
  // add sentry only if prod env
  enhancers = [sentryEnhancer]
}

const store = configureStore({
  reducer,
  devTools: isDevEnv,
  enhancers: (defaultEnhancers: readonly StoreEnhancer[]): StoreEnhancer[] => [...defaultEnhancers, ...enhancers],
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: true, serializableCheck: false })
      .concat(routingApi.middleware)
      .concat(save({ states: PERSISTED_KEYS, debounce: 1000 })),
  preloadedState: load({ states: PERSISTED_KEYS, disableWarnings: isTestEnv() }),
})

store.dispatch(updateVersion())

setupListeners(store.dispatch)

export default store
